import { Dic } from "@src/common/utils";
import utils from "@src/common/utils";
const checkTableOption = function (that) {
  return {
    page: true,
    index: true,
    indexLabel: "序号",
    refreshBtn: false,
    columnBtn: false,
    stripe: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    align: "left",
    size: "small",
    maxHeight: "200%",
    menuWidth: 200,
    menuAlign: "center",
    searchMenuSpan: 6,
    searchBtn: false,
    dialogHeight: 400,
    labelSuffix: " ：",
    labelWidth: "98px",
    dialogWidth: "800px",
    viewDialogWidth: "700",
    emptyText: "暂无核对数据",
    column: [
      {
        label: "sheet页名称",
        prop: "sheetName",
        overHidden: true,
        columnWidth: "100",
      },
      {
        label: "客户名称",
        prop: "custom",
        overHidden: true,
        columnWidth: "200",
      },
      {
        label: "司机姓名",
        prop: "driverName",
        overHidden: true,
        columnWidth: "200",
      },
      {
        label: "电话",
        prop: "phone",
        overHidden: true,
        columnWidth: "200",
      },
      {
        label: "前车车牌",
        prop: "frontPlate",
        searchPlaceholder: "请输入前车车牌",
        columnWidth: "200",
      },
      {
        label: "柜号",
        prop: "cabinetNumber",
        searchPlaceholder: "请输入柜号",
        columnWidth: "200",
      },
      {
        label: "作业类型",
        prop: "operateType",
        searchPlaceholder: "请选择作业类型",
        formatter: (row, value) => {
          if (Number(value) === 1) {
            return "装货";
          } else if (Number(value) === 2) {
            return "卸货";
          } else if (Number(value) === 3) {
            return "过车";
          }
          return "";
        },
        columnWidth: "300",
      },
      {
        label: "操作类型",
        prop: "passType",
        searchPlaceholder: "请选择操作类型",
        formatter: (row, value) => {
          if (Number(value) === 1) {
            return "倒入";
          } else if (Number(value) === 2) {
            return "倒出";
          }
          return "";
        },
        columnWidth: "200",
      },
      {
        label: "货品名称",
        prop: "waresName",
        columnWidth: "200",
      },
      {
        label: "数量",
        prop: "waresCount",
        overHidden: true,
        columnWidth: "200",
      },
      {
        label: "重量",
        prop: "waresWeight",
        columnWidth: "200",
      },
      {
        label: "库位",
        prop: "warehouseNumber",
        columnWidth: "200",
      },
      {
        label: "预约日期",
        prop: "estimatedArrivalTime",
        overHidden: true,
        columnWidth: "200",
      },
      {
        label: "入库日期",
        prop: "warehousingDate",
        overHidden: true,
        columnWidth: "200",
      },
    ],
  };
};
export default checkTableOption;
